export default {
  serveIndex: {
    navList: [
      "AUTHENTICITY AND QUALITY ASSURANCE SERVICE",
      "FINANCIAL AND INSURANCE SERVICES", 
      "CUSTOMS SERVICE",
      "LOGISTICS SERVICE",
      "LEGAL SERVICE",
      "FOREIGN TRADE SERVICE",
      "TALENT AND TRAINING SERVICES"
    ]
  }
}